import api from "./changeLoginApi";
import { changeLoginError, changeLoginInit, changeLoginPending, changeLoginSuccess } from "./changeLoginStateActions";
import { parseApiError } from "../../../utils/apiError";
import { signoutRedirect } from "../auth/authServices";

export type ChangeLoginStatus = "Initial" | "Pending" | "Success" | "Errored";

export function ChangeLogin(
  dispatch: any,
  customerAccountId: number,
  customerContactId: number,
  newLoginEmail: string
) {
  dispatch(changeLoginPending());
  api
    .loginEmailChange(customerAccountId, customerContactId, newLoginEmail, true)
    .then(
      function (value) {
        dispatch(changeLoginSuccess());
        setTimeout(() => {
          signoutRedirect();
        }, 3000);
      },
      function (error: unknown) {
        const parsed = parseApiError(
          error,
          "An error ocurred while trying to change your email. Please try again later"
        );
        dispatch(changeLoginError(parsed.message, parsed.correlationId));
      }
    )
    .finally(function () {
      setTimeout(() => {
        dispatch(changeLoginInit());
      }, 500);
    });
}

export function InitChangeLogin() {
  return function (dispatch: any) {
    dispatch(changeLoginInit());
  };
}
